import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { AutomaticPayment } from "../../graphql/payments.datatypes";

interface AutomaticPaymentData {
    automaticPayment: AutomaticPayment;
}

const automaticPayment = `
    id
    payment_token
    payment_frequency
    payment_type
    last_four
    routing_number
    billingPartyMember {
        id
    }
    billingParty {
        id
    }
    paymentSchedule {
        id
        description
        dates {
            id
            payment_schedule_id
            title
            due_date
            action_type
            amount
            amount_type
            completed
            calculatedAmount
        }
        payment_dates {
            id
            payment_schedule_id
            title
            due_date
            action_type
            amount
            amount_type
            completed
            calculatedAmount
        }
    }
`;

export const FETCH_AUTOMATIC_PAYMENT = gql`
    query getAutomaticPayment($id: Int!) {
        automaticPayment(id: $id) {
            ${automaticPayment}
        }
    }
`;

export const fetchAutomaticPayment = (id: number) => {
    return useQuery<AutomaticPaymentData>(FETCH_AUTOMATIC_PAYMENT, {
        variables: { id }
    });
};

export default fetchAutomaticPayment;
